import React from 'react';
import { useTabsContext } from '../context/TabsContext';
import { TabPanelOption, TabsConfig } from '../types/TabsConfig';

type LbTabsPanelProps = {
  tabsConfig: TabPanelOption[] | TabsConfig[];
};

const LbTabPanel = ({ tabsConfig }: LbTabsPanelProps) => {
  const { value } = useTabsContext();

  return (
    <>
      {tabsConfig.map((tab) => (
        <div
          key={tab.value}
          role="tabpanel"
          id={`panel-${tab.value}`}
          aria-labelledby={`tab-${tab.value}`}
          // minWidth: 0 prevents grid/flex items from expanding beyond container (allows overflow scroll)
          style={{ display: value === tab.value ? 'block' : 'none', minWidth: 0 }}
        >
          {value === tab.value && tab.panel}
        </div>
      ))}
    </>
  );
};

export { LbTabPanel, LbTabsPanelProps };
